import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./NotFound.css";

const NotFound = () => {
  return (
    <Container className="not-found">
      <Row>
        <Col className="text-center">
          <h3 className="not-found-h3">404</h3>
          <h1 className="not-found-h1">
            Strona nie{" "}
            <span className="not-found-span">została znaleziona</span>
          </h1>
          <p className="not-found-text">
            Strona, której szukasz, nie istnieje lub została przeniesiona.
          </p>
          <Link to="/" className="not-found-link">
            Wróć na stronę główną
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;
